import { EmptyStateView } from "@app/components/EmptyStateView.tsx";
import {
  getModuleIdForPathname,
  moduleLabels,
} from "@app/components/moduleRoutes.ts";
import { Page } from "@app/components/Page.tsx";
import {
  peopleSectionTabs,
  SectionTabs,
} from "@app/components/SectionTabs.tsx";
import { Button } from "@app/components/shadcn/button.tsx";
import { useEnterpriseModules } from "@app/hooks/useEnterpriseModules.ts";
import type { PropsWithChildren } from "react";

export function ModuleGate({
  pathname,
  children,
}: PropsWithChildren<{ pathname: string }>) {
  const moduleId = getModuleIdForPathname(pathname);
  const { modules, isLoading, isError, refetch } = useEnterpriseModules({
    enabled: !!moduleId,
  });

  if (!moduleId || (!isLoading && !isError && modules?.includes(moduleId))) {
    return children;
  }

  const label = moduleLabels[moduleId];
  return (
    <Page title={label} isLoading={isLoading}>
      {moduleId === "employees" || moduleId === "early-payments" ? (
        <SectionTabs tabs={peopleSectionTabs} />
      ) : null}
      {isLoading ? null : isError || !modules ? (
        <EmptyStateView>
          <p>Não foi possível verificar os módulos desta empresa.</p>
          {isError ? (
            <Button
              variant="outline"
              className="mt-4"
              onClick={() => void refetch()}
            >
              Tentar novamente
            </Button>
          ) : null}
        </EmptyStateView>
      ) : (
        <EmptyStateView>
          O módulo {label} não está habilitado para esta empresa.
        </EmptyStateView>
      )}
    </Page>
  );
}
